import { BookOpen, EnvelopeSimple, GithubLogo, LinkedinLogo, XLogo } from '@phosphor-icons/react/dist/ssr'
import Link from 'next/link'

const socialLinks = [
  { href: 'mailto:mateas.branislav@gmail.com', label: 'Send me an email', icon: EnvelopeSimple },
  { href: 'https://www.linkedin.com/in/branislav-mateas/', label: 'LinkedIn profile', icon: LinkedinLogo },
  { href: 'https://x.com/mateasbranislav', label: 'X profile', icon: XLogo },
  { href: 'https://github.com/BranislavMateas', label: 'GitHub profile', icon: GithubLogo },
  { href: 'https://www.goodreads.com/user/show/197060938-branislav-mate', label: 'Goodreads profile', icon: BookOpen },
]

export default function Footer() {
  return (
    <footer className="border-t border-[var(--portfolio-line)] bg-[var(--portfolio-paper)] px-4 py-8 text-[var(--portfolio-muted)] sm:px-6">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-sm">© {new Date().getFullYear()} Branislav Mateáš. All rights reserved.</p>
          <Link href="/cookies" className="mt-2 inline-block text-sm underline decoration-[#00E59E] decoration-2 underline-offset-4 hover:text-[var(--portfolio-ink)]">Cookies Policy</Link>
        </div>
        <div className="flex flex-wrap gap-2">
          {socialLinks.map(({ href, label, icon: Icon }) => (
            <a
              key={href}
              href={href}
              target={href.startsWith('http') ? '_blank' : undefined}
              rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
              aria-label={label}
              title={label}
              className="inline-flex size-11 items-center justify-center rounded-[8px] border border-[var(--portfolio-line)] bg-[var(--portfolio-surface)] text-[var(--portfolio-ink)] transition hover:border-[#00AD78] hover:text-[var(--portfolio-accent-text)]"
            >
              <Icon size={21} weight="regular" aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}
